import Vue from 'vue'
// eslint-disable-next-line import/named
import { permissionDirective } from './permission-directive'
import padLeftZeroDirective from './padLeftZero'

Vue.directive('isAllowed', permissionDirective)
Vue.directive('padLeftZero', padLeftZeroDirective)
